import { z } from 'zod';

/** UUID или public-id (`tkt_xxxx`). API принимает оба, в БД хранится UUID. */
export const idSchema = z.string().min(1).max(64);

/** ISO timestamp */
export const isoDateSchema = z.string().datetime({ offset: true });

/** Email с трим/lowercase */
export const emailSchema = z.string().email().toLowerCase().trim().max(254);

/** Phone — мягкая проверка (E.164-friendly), без жёстких правил */
export const phoneSchema = z
  .string()
  .trim()
  .min(5)
  .max(32)
  .regex(/^\+?[0-9() \-\s]+$/);

/** Slug */
export const slugSchema = z
  .string()
  .min(2)
  .max(48)
  .regex(/^[a-z0-9](?:[a-z0-9_-]*[a-z0-9])?$/i);

/** Tags — массив коротких строк */
export const tagsSchema = z.array(z.string().min(1).max(64)).max(50);

/** Generic JSON metadata */
export const jsonMetaSchema = z.record(z.unknown());

/** Локаль (ru/en/...) */
export const localeSchema = z.string().min(2).max(8);

/** Цветовой hex (для виджета) */
export const hexColorSchema = z.string().regex(/^#(?:[0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i);

/** UTM-метки */
export const utmSchema = z
  .object({
    source: z.string().max(128).optional(),
    medium: z.string().max(128).optional(),
    campaign: z.string().max(128).optional(),
    term: z.string().max(128).optional(),
    content: z.string().max(128).optional(),
  })
  .partial();

/** Geo (страна/город из IP) */
export const geoSchema = z
  .object({
    country: z.string().min(2).max(2).optional(),
    city: z.string().max(128).optional(),
    ip: z.string().max(64).optional(),
  })
  .partial();

/** Idempotency-key */
export const idempotencyKeySchema = z.string().min(8).max(255);
